module.exports = __webpack_public_path__ + "img/logo_horizontal.5861d166.svg";